export default userAgent => {
  return userAgent ? userAgent : {
    browser: {},
    os: {},
    device: {}
  };
};
